/** Thin re-export so pages import a stable `useSession` name. */
import { useSessionContext } from './AuthProvider'

export type { SessionContextValue } from './AuthProvider'

export function useSession() {
  return useSessionContext()
}
